export function enabledSpecializations(employee) {
    if (!employee.use_specializations_for_patient_portal) {
        return [];
    }

    const disabled = employee.disabled_specializations || [];

    return (employee.specializations || []).filter(specialization => !disabled.includes(specialization.key));
}

function hasRouting(employee) {
    return enabledSpecializations(employee).length > 0 || (employee.complaint_area_ids || []).length > 0;
}

export function missesRouting(employee) {
    return employee.online_daypart_count > 0 && !hasRouting(employee);
}

export function isFindable(employee) {
    return employee.online_daypart_count > 0 && hasRouting(employee);
}
